import { Box, styled } from '@mui/material';

const StyledImageUploadContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));

export default StyledImageUploadContainer;
